import { SortingRule } from 'react-table';

export const getSortColumn = (sortBy: Array<SortingRule<any>>): string | undefined => {
  if (sortBy.length <= 0) {
    return undefined;
  }
  const sortString = sortBy[0].id.toLowerCase().replace(/ /g, '');
  const order = sortBy[0].desc ? '+' : '-';

  return `${order}${sortString}`;
};
